module.exports = __webpack_public_path__ + "static/media/kendrafoundit-IG-10.621e03c2.PNG";